import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import lodash from 'lodash';
import styles from 'common/containers/Events/EventsConfiguration.scss';
import EventsConfiguration from './EventsConfiguration';

import {
    getInstitutionEventTypes,
    clearInstitutionEventTypes,
    toggleInstitutionEventType,
} from 'common/actions/eventTypes';

export function InstitutionalAdminEventConfiguration(props) {
    return <EventsConfiguration
        className={styles.institutionalAdmin}
        viewEventTypeURLBuilder={(eventTypeId) => `/admin/events/edit/${eventTypeId}`}
        {...props }
    />;
}

export default connect((state) => {
    const institutionId = lodash.get(state, 'me.institution.id');
    const eventTypes = lodash.get(state, 'eventTypes', []);
    return {
        institutionId,
        eventTypes
    };
}, {
    getInstitutionEventTypes,
    clearInstitutionEventTypes,
    toggleInstitutionEventType,
    onCreateEvent: () => push('/admin/events/create'),
})(InstitutionalAdminEventConfiguration);
